export default "/images/audit_badge/audit_badge_bg.png";